// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2zeky";
var _3 = "wrapper_business-2k28s";
var _4 = "row-185Gj";
var _5 = "header-16tKu";
var _6 = "header__logo-3wbgS";
var _7 = "info__col-2lZum";
var _8 = "info__iata-1XI_u";
var _9 = "info__cities-2QFgc";
var _a = "info__time-38xY6";
var _b = "disabled-f_lbw";
var _c = "info__plane-2KpJ7";
var _d = "arrivalInfo-sDeW8";
var _e = "arrivalInfo__item-3wg2o";
var _f = "arrivalInfo__itemLabel-1w4ti";
var _10 = "arrivalInfo__itemValue-1t39J";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_business", _4 as "row", _5 as "header", _6 as "header__logo", _7 as "info__col", _8 as "info__iata", _9 as "info__cities", _a as "info__time", _b as "disabled", _c as "info__plane", _d as "arrivalInfo", _e as "arrivalInfo__item", _f as "arrivalInfo__itemLabel", _10 as "arrivalInfo__itemValue" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_business": _3, "row": _4, "header": _5, "header__logo": _6, "info__col": _7, "info__iata": _8, "info__cities": _9, "info__time": _a, "disabled": _b, "info__plane": _c, "arrivalInfo": _d, "arrivalInfo__item": _e, "arrivalInfo__itemLabel": _f, "arrivalInfo__itemValue": _10 }
